import { DownloadButton } from "@ugitgud/legos/ui/form/button/DownloadButton";
import { Icon } from "@ugitgud/legos/ui/icon/Icon";
import { SvgArrowLineRight } from "@ugitgud/legos/ui/icon/SVG/ArrowLineRight";
import { SvgMiscDownloadFill } from "@ugitgud/legos/ui/icon/SVG/MiscDownloadFill";
import { SvgMiscX } from "@ugitgud/legos/ui/icon/SVG/MiscX";
import classNames from "classnames";

export const HIGHLIGHTS_CTA_ID = "app-highlights-2";

interface HighlightsBannerProps {
  url: string;
  className?: string;
  onClick: (url: string) => void;
  onClose?: () => void;
  utmSource?: string;
}

export function HighlightsBanner(props: HighlightsBannerProps) {
  const { url, onClick, onClose, className, utmSource } = props;

  const href = utmSource ? `${url}?utm_source=${utmSource}` : url;

  const onUrlClick = (e: React.MouseEvent) => {
    e.preventDefault();
    onClick(href);
  };

  return (
    <div
      className={classNames(
        className,
        `
        h-[48px] relative px-[12px] w-full bg-no-repeat bg-right bg-accent-gray-75
        bg-[url('https://static.bigbrain.gg/assets/ugg/cta/highlights-banner.png')]
    `,
      )}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-purple-400 to-purple-400/0 z-0" />
      <div
        className={classNames("flex items-center relative justify-between xs:justify-center gap-2 xs:gap-[18px] h-full", {
          "pr-8 xs:pr-0": onClose,
        })}
      >
        <div className="[text-shadow:0px_1px_0px_rgba(0,_0,_0,_0.50)]">
          <div className="font-bold text-[14px] xs:text-[18px] text-white">
            <span className="!font-barlow-condensed capitalize">NEVER MISS YOUR HIGHLIGHTS</span>
          </div>
          <div className="font-inter font-medium text-[10px] xs:text-[12px] text-white">
            Auto-save your best plays with the U.GG app
          </div>
        </div>
        <div
          className="flex items-center justify-between h-[30px] bg-accent-blue-400 rounded-sm py-1.5 xs:py-2.5 pl-2 xs:pl-3 pr-1 cursor-pointer hover:bg-accent-blue-600 whitespace-nowrap"
          onClick={onUrlClick}
        >
          <span className="font-bold text-[10px] xs:text-[11px]">Check it out</span>
          <Icon icon={<SvgArrowLineRight />} className="w-5 h-5 xs:w-6 xs:h-6 text-white" />
        </div>
      </div>
      {onClose && (
        <div
          className="absolute top-[50%] right-[12px] translate-y-[-50%] p-[6px] cursor-pointer hover:opacity-50 z-[1]"
          onClick={onClose}
        >
          <Icon icon={<SvgMiscX />} size="xs" className="fill-white drop-shadow-[0px_1px_0px_rgba(0,_0,_0,_0.50)]" />
        </div>
      )}
    </div>
  );
}
